let _ = t => t,
  _t;
import styled from 'styled-components';
export const MaxWidthText = styled.div(_t || (_t = _`
  max-width: 70ch;
`));
export default MaxWidthText;